import { render, staticRenderFns } from "./adjust-record.vue?vue&type=template&id=1f8dc51a&scoped=true&"
import script from "./adjust-record.vue?vue&type=script&lang=js&"
export * from "./adjust-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8dc51a",
  null
  
)

export default component.exports